import "./EmployeesTable.scss"
import React, { useState } from 'react'
import GenericDataTable from '../../../../components/generic-datatable/GenericDataTable'
import { Column } from 'primereact/column'
import { EMPLOYEES_TABLE_HEADER, EMPLOYEES_TABLE_KEYS, employeesTableData } from './EmployeesTable.config'
import { InputSwitch } from "primereact/inputswitch"
import ModalContainer from "../../../../components/modal-container/ModalContainer"
import { useToggle } from "../../../../hooks"
import PrimaryButton from "../../../../components/button/PrimaryButton"
import { useGetAllEmployeesQuery } from "../../../../services/kmt/employeeCenter"
import CenteredSpinner from "../../../../components/centered-spinner/CenteredSpinner"
import { EMPLOYEE_DEPARTMENTS } from "../../../../config/departments"
import { ReactComponent as PencilIcon } from "../../assets/pencil-outline.svg";
import { ReactComponent as TrashIcon } from "../../../../assets/sales/TrashIcon.svg";

const EmployeesTable = ({setEmployeeDetailsOnEdit,setDisplayAddModal, setIsEdit, setDisplayDeleteModal}) => {
    const { data: employeeList, isLoading } = useGetAllEmployeesQuery()
    const [modalVisible, setModalVisible] = useToggle(false)
    if (isLoading) {
        return <CenteredSpinner />
    }
    let rowClassName = data => {
        if (data.department === EMPLOYEE_DEPARTMENTS.CLIENT_SERVICES) {
            return "client-services"
        }
        else if (data.department === EMPLOYEE_DEPARTMENTS.SALES) {
            return "sales"
        }
        else if (data.department === EMPLOYEE_DEPARTMENTS.KNOWLEDGE_MANAGEMENT) {
            return "knowledge-management"
        }
    }
    const setEditDetails = (data) => {
        const {_id, firstName, lastName, email, department} = data
        setEmployeeDetailsOnEdit({firstName, lastName, email, department, _id})
    }
    const bodyTemplate = (data, column) => {
        console.log(data)
        if (column.field === EMPLOYEES_TABLE_KEYS.EDIT) {
            return (
                <div className="flex justify-content-center align-items-center gap-3">
                    <div className="cursor-pointer" style={{height:"1.5rem", width:"1.5rem"}} onClick={() => {setIsEdit(true);setEditDetails(data); setDisplayAddModal()}}>
                        <PencilIcon />
                    </div>
                    <div className="cursor-pointer" style={{height:"1.5rem", width:"1.5rem"}} onClick={() => { setDisplayDeleteModal();setEditDetails(data);}}>
                        <TrashIcon />
                    </div>
                </div>
            )
        }
    }
    return (
        <div className="EmployeesTable font-bold">
            <ModalContainer onHide={setModalVisible} headerClassName="text-white" style={{ width: "50%" }} visible={modalVisible} header="Are you sure you want to toggle the status of the account?">
                <div className="flex flex-column align-items-center p-3">
                    <h6 className="mb-5">Are you sure you want to Activate/Deactivate the status of this account?</h6>
                    <div className="flex align-items-center gap-4">
                        <PrimaryButton onClick={setModalVisible} variant="flat">Cancel</PrimaryButton>
                        <PrimaryButton onClick={setModalVisible} variant="outline">Confirm</PrimaryButton>
                    </div>
                </div>
            </ModalContainer>
            <GenericDataTable
                rowClassName={rowClassName} paginator rows={10} tableClassName='white-space-nowrap font-medium' spacedRows={true} value={employeeList} sortMode="multiple" responsiveLayout="scroll">
                <Column field={EMPLOYEES_TABLE_KEYS.FIRST_NAME} header={EMPLOYEES_TABLE_HEADER[EMPLOYEES_TABLE_KEYS.FIRST_NAME]} align="center" />
                <Column field={EMPLOYEES_TABLE_KEYS.LAST_NAME} header={EMPLOYEES_TABLE_HEADER[EMPLOYEES_TABLE_KEYS.LAST_NAME]} align="center" />
                <Column field={EMPLOYEES_TABLE_KEYS.EMAIL} header={EMPLOYEES_TABLE_HEADER[EMPLOYEES_TABLE_KEYS.EMAIL]} align="center" />
                <Column field={EMPLOYEES_TABLE_KEYS.DEPARTMENT} header={EMPLOYEES_TABLE_HEADER[EMPLOYEES_TABLE_KEYS.DEPARTMENT]} align="center" />
                <Column field={EMPLOYEES_TABLE_KEYS.DESIGNATION} header={EMPLOYEES_TABLE_HEADER[EMPLOYEES_TABLE_KEYS.DESIGNATION]} align="center" />
                <Column field={EMPLOYEES_TABLE_KEYS.EMPLOYEE_CODE} header={EMPLOYEES_TABLE_HEADER[EMPLOYEES_TABLE_KEYS.EMPLOYEE_CODE]} align="center" />
                <Column field={EMPLOYEES_TABLE_KEYS.EDIT} body={bodyTemplate} header={EMPLOYEES_TABLE_HEADER[EMPLOYEES_TABLE_KEYS.EDIT]} align="center" />
            </GenericDataTable>
        </div>
    )
}

export default EmployeesTable